export function checkE164Format(phoneNumbers: string) {
  for (let i = 0; i < phoneNumbers.length; i += 1) {
    if (!/^\+[1-9]\d{1,14}$/u.test(phoneNumbers[i])) {
      return false;
    }
  }
  return true;
}

export function getTypeOfInstance(obj: any) {
  const objectType = obj.constructor.toString();
  if (objectType.indexOf("String") !== -1) {
    return "string";
  }
  if (objectType.indexOf("Array") !== -1) {
    return "array";
  }
  if (objectType.indexOf("Object") !== -1) {
    return "object";
  }
  return "NA";
}
